module.exports = __webpack_public_path__ + "static/media/banner_m_06.b78b403c.jpg";